import { Routes } from "@angular/router";

export const quotationRoutes: Routes = [
  {
    path: "",
    loadChildren: () => import("./domains/quotations/quotations.routes").then(m => m.quotationsRoutes),
  },
];

export const customQuotationRoutes: Routes = [
  {
    path: "",
    loadChildren: () => import("./domains/custom-quotation/custom-quotation.routes").then(m => m.customQuotationRoutes),
  },
];
